import { HTTP } from './http-common'

export default {
  async getProjectList() {
    return await HTTP.get('/projects')
  },
  getProject(projectId) {
    return HTTP.get(`/projects/${projectId}/`)
  },
  getBuildings(projectId) {
    return HTTP.get('/projects/' + projectId)
  },
  getOpeningCountForBuilding(projectId, buildingId) {
    return HTTP.get(`/projects/${projectId}/openingCountForBuilding/${buildingId}`)
  },
  getLastModificationForBuilding(projectId, buildingId) {
    return HTTP.get(`/projects/${projectId}/lastModificationForBuilding/${buildingId}`)
  },
  getOpeningCountForFloor(projectId, buildingId) {
    return HTTP.get(`/projects/${projectId}/openingCountForFloor/${buildingId}`)
  },
  getLastModificationForFloor(projectId, storyId) {
    return HTTP.get(`/projects/${projectId}/lastModificationForFloor/${storyId}`)
  },
  getOpeningCountForZone(projectId, zoneId) {
    return HTTP.get(`/projects/${projectId}/openingCountForZone/${zoneId}`)
  },
  getLastModificationForZone(projectId, zoneId) {
    return HTTP.get(`/projects/${projectId}/lastModificationForZone/${zoneId}`)
  },
  createProject(projectData) {
    //TODO: Stijn, why return the res in a then block and not just use await in the calling funtion?
    return HTTP.post('/projects/', projectData).then(res => {
      return res
    })
  },
  deleteProject(projectId) {
    return HTTP.delete('/projects/' + projectId)
  },
  getUserClaimsProject(projectId) {
    return HTTP.get(`/projects/${projectId}/claims`)
  },
  assignBuildingToProject(payload) {
    return HTTP.post(`/projects/${payload.projectId}/buildings?name=${payload.name}`)
  },
  // async assignBuildingToProject(payload) {
  //   return await HTTP.post(`/projects/${payload.projectId}`).then(res => {
  //     return res
  //   })
  // },
  async updateProject(projectData) {
    return await HTTP.put(`/projects/${projectData.projectId}`, projectData).then(res => {
      return res
    })
  },
  async deleteBuilding(projectId, buildingId) {
    return await HTTP.delete(`/projects/${projectId}/buildings/${buildingId}`).then(res => {
      return res
    })
  },
  assignStoryToBuilding(payload) {
    return HTTP.post(`/projects/${payload.projectId}/stories/?buildingId=${payload.buildingId}&name=${payload.name}`)
  },
  assignZoneToStory(payload) {
    return HTTP.post(`/projects/${payload.projectId}/zones/?storyId=${payload.storyId}&name=${payload.name}`)
  },
  getProjectStatus(payload) {
    return HTTP.get(
      `/projects/StatusChecker/${payload.projectId}?mode=${payload.mode}&startDateValue=${payload.startDate}&endDateValue=${payload.endDate}`
    )
  },
  async deleteFloor(projectId, floorId) {
    return await HTTP.delete(`/projects/${projectId}/stories/${floorId}`).then(res => {
      return res
    })
  },
  async deleteZone(projectId, zoneId) {
    return await HTTP.delete(`/projects/${projectId}/zones/${zoneId}`).then(res => {
      return res
    })
  },
  async getZone(projectId, zoneId) {
    return await HTTP.get(`/projects/${projectId}/zones/${zoneId}`).then(res => {
      return res
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/projectService.js